import React, { useEffect } from "react";

import './AdminActions.css';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUser } from "../../features/home/userSlice";
import { loadBankSettings, selectBankSettings } from "../../features/manageBankSettings/bankSettingsSlice";
import { selectToken } from "../../features/login/loginSlice";

export default function AdminActions() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;
    const bankId = userInfo.bankId;
    const bankSettings = useSelector(selectBankSettings);

    useEffect(() => {
        if (!bankSettings.id && userRole !== 'SUPERADMIN' && bankId && token) {
            dispatch(loadBankSettings({bankId, token}))
        }
    }, [bankSettings, bankId, dispatch, token, userRole])
    

    return (
        <section className="admin-actions">
            <h2>{`${userRole === 'TELLER' ? 'Teller Actions' : 'Administrative Actions'}`}</h2>
            {(userRole === 'TELLER' && bankSettings.tellerDepositPermission) || userRole === 'ADMIN' ? <Link to={`/${bankId}/deposit`}>
                <article>
                    <h3>Deposit Money</h3>
                </article>
            </Link> : ""}
            {(userRole === 'TELLER' && bankSettings.tellerWithdrawalPermission) || userRole === 'ADMIN' ? <Link to={`/${bankId}/withdrawal`}>
                <article>
                    <h3>Withdraw Money</h3>
                </article>
            </Link> : ""}
            {(userRole === 'TELLER' && bankSettings.tellerTransferPermission) || userRole === 'ADMIN' ? <Link to={`/${bankId}/transfer`}>
                <article>
                    <h3>Transfer Money</h3>
                </article>
            </Link> : ""}
            {userRole !== 'SUPERADMIN' ? "" : (
                <Link to={`/admin/banks`}>
                    <article>
                        <h3>Manage Banks</h3>
                    </article>
                </Link>
            )}
            {userRole !== 'ADMIN' && userRole !== 'SUPERADMIN' ? "" : (
                <Link to={`/${bankId}/admin/branches`}>
                    <article>
                        <h3>Manage Branches</h3>
                    </article>
                </Link>
            )}
            {userRole !== 'ADMIN' && userRole !== 'SUPERADMIN' ? "" : (
                <Link to={`/${bankId}/admin/users`}>
                    <article>
                        <h3>Manage Users</h3>
                    </article>
                </Link>
            )}
            {userRole !== 'ADMIN' && userRole !== 'SUPERADMIN' ? "" : (
                <Link to={`/${bankId}/admin/accounts`}>
                    <article>
                        <h3>Manage Accounts</h3>
                    </article>
                </Link>
            )}
        </section>
    )
    
}